'use client';

import { Box, Divider, Typography } from '@mui/material';

import { BuscaPatrocinadaProductItem } from '~/types/keywordPerformance';

type FieldProps = { label: string; value: string | number };

function Field({ label, value }: FieldProps) {
  const isEmpty =
    value === '' ||
    value === null ||
    value === undefined ||
    value === '0' ||
    value === 0;
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, minWidth: 0 }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: isEmpty ? 400 : 600, whiteSpace: 'nowrap' }}
        color={isEmpty ? 'text.disabled' : 'text.primary'}
      >
        {isEmpty ? '—' : value}
      </Typography>
    </Box>
  );
}

type Props = { item: BuscaPatrocinadaProductItem };

export function ProductApiExpandedRow({ item }: Props) {
  return (
    <Box
      sx={{
        px: 4,
        py: 2.5,
        backgroundColor: theme =>
          theme.palette.mode === 'light' ? '#F7F8FE' : '#111122',
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {item.keywordList?.length > 0 && (
        <Box sx={{ py: 1 }}>
          <Typography
            variant="overline"
            color="text.disabled"
            sx={{
              letterSpacing: 1,
              fontSize: '0.65rem',
              display: 'block',
              mb: 1,
            }}
          >
            Palavras-chaves associadas
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
            {item.keywordList.map(kw => (
              <Box
                key={kw}
                sx={{
                  px: 1.25,
                  py: 0.5,
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  backgroundColor: theme =>
                    theme.palette.mode === 'light' ? '#fff' : '#1A1A2E',
                }}
              >
                <Typography variant="caption" sx={{ fontWeight: 600 }}>
                  {kw}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}

      <Divider />

      <Box sx={{ py: 1 }}>
        <Typography
          variant="overline"
          color="text.disabled"
          sx={{
            letterSpacing: 1,
            fontSize: '0.65rem',
            display: 'block',
            mb: 1,
          }}
        >
          Métricas de Custo
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
            gap: 2,
          }}
        >
          <Field label="CPM" value={item.cpm} />
          <Field label="CPI" value={item.cpi} />
          <Field label="CPC" value={item.cpc} />
        </Box>
      </Box>

      {item.advertiser && (
        <>
          <Divider />
          <Box sx={{ py: 1 }}>
            <Typography
              variant="overline"
              color="text.disabled"
              sx={{
                letterSpacing: 1,
                fontSize: '0.65rem',
                display: 'block',
                mb: 1,
              }}
            >
              Anunciante
            </Typography>
            <Box
              sx={{
                display: 'inline-block',
                px: 1.25,
                py: 0.5,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: theme =>
                  theme.palette.mode === 'light' ? '#fff' : '#1A1A2E',
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                {item.advertiser}
              </Typography>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
